import React from 'react';
import MoonLoader from 'react-spinners/MoonLoader';
import check_circle from './img/bx-check-circle.svg';
import './SaveIndicator.scss'

interface SaveIndicatorProps {
    isSave: boolean;
}

const SaveIndicator: React.FC<SaveIndicatorProps> = ({ isSave }) => {
    return (
        <div className="save-indicator">
            {isSave ?
                <>
                    <img src={check_circle} alt="Saved" />
                    <p style={{ color: '#00B45E' }}>Сохранено!</p>
                </>
                :
                <>
                    <MoonLoader size={18} color="#7b7b7b" speedMultiplier={0.5} />
                    <p>Идет сохранение...</p>
                </>
            }
        </div>
    );
};

export default SaveIndicator;